import getCurrentUser from "@/helper/getCurrentUser";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || 'https://webapp-api.meetingroomz.com/api/v1/',
  prepareHeaders: (headers, context) => {
    const access_token = getCurrentUser()?.token;
    headers.set("Accept", "application/json");
    if (access_token) {
      headers.set("Authorization", access_token);
    }
    return headers;
  },
});


// Custom function to handle token refresh
// const baseQueryWithReauth = async (args, api, extraOptions) => {
//   const state = api.getState();
//   const { refresh_token, expires_at, user } = state.auth || {};

//   const isTokenExpired =
//     (!expires_at && !user?.expires_at) ||
//     new Date(expires_at || user?.expires_at) <= new Date();
//   console.log(
//     "apislice isTokenExpired:>>>>",
//     isTokenExpired,
//     expires_at,
//     user?.expires_at && new Date(user?.expires_at) <= new Date()
//   );

//   // If the token is expired or close to expiry, refresh it before making a request
//   if (isTokenExpired && refresh_token) {
//     console.log("Access token is expired or close to expiry, refreshing...");

//     const refreshResult = await baseQuery(
//       {
//         url: "/auth/refresh-token",
//         method: "POST",
//         body: { token: refresh_token },
//       },
//       api,
//       extraOptions
//     );

//     console.log("refreshResult:>>>>>>", refreshResult);

//     if (refreshResult?.data) {
//       const accessToken = refreshResult.data.data;

//       api.dispatch(setCredentials(accessToken));
//     } else {
//       console.log("Refresh token failed, logging out...");
//       api.dispatch(logout());
//       return refreshResult;
//     }
//   }

//   // Make the actual API request with the (new) access token
//   let result = await baseQuery(args, api, extraOptions);

//   // If still unauthorized after refresh, log out
//   if (result?.error?.status === 401) {
//     console.log(
//       "Access token expired, and refresh attempt failed, logging out..."
//     );
//     api.dispatch(logout());
//   }

//   return result;
// };


export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    sendOTP: builder.mutation({
      query: ({ requestId, userId }) => ({
        url: "/recipients/send-otp",
        method: "POST",
        body: { requestId, userId },
      }),
    }),
    verifyOTP: builder.mutation({
      query: ({ requestId, userId, OTP }) => ({
        url: "/recipients/verify-otp",
        method: "POST",
        body: { requestId, userId, OTP },
      }),
    }),
    getDoc: builder.query({
      query: ({ requestId, userId }) => ({
        url: "/recipients/get-doc",
        method: "GET",
        params: { requestId, userId },
      }),
    }),
    attachESign: builder.mutation({
      query: (body) => ({
        url: "/recipients/attach-esign",
        method: "POST",
        body: body,
      }),
    }),
    getPDFByURL: builder.mutation({
      query: (url) => ({
        url: url,
        method: "GET",
      }),
    })
  }),
});

export const {
  useSendOTPMutation,
  useVerifyOTPMutation,
  useGetDocQuery,
  useAttachESignMutation,
  useGetPDFByURLMutation
} = apiSlice;
